import React from 'react'

import { Lang } from '../../types/common-types'
import AccountForm from '../../types/account-form.types'
import styles from './ErrorScreen.module.scss'
import Button from '../../shared/Buttons/Button'

interface Props {
  accountForm: AccountForm
  lang: Lang
  step?: number
  onError: () => void
  onAccept?: () => void
}

const ErrorScreen: React.FC<Props> = ({
  accountForm,
  lang,
  step,
  onError,
  onAccept,
}: Props) => {
  return (
    <div className={styles.error}>
      <div>
        <span className={styles.errorSpan}>:(</span>
        <p className={styles.errorMessage}>{accountForm.submitError[lang]}</p>
        <Button uppercase={true} bg={'hollow'} testName={step === 1 ? 'cancelButton' : 'prevButton'} value={accountForm.prevButton[lang]}
          onClick={onError}
        ></Button>
      </div>
    </div>
  )
}

export default ErrorScreen
